






import Vue from 'vue';
import { Notification } from '@/libs/EventBus';

export default Vue.extend({
  mounted() {
    Notification.$on('notify', (options: NotificationOptions) => {
      this.$notify(options);
    });
  },
});
